/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand>): BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand {
        let obj = Object.assign(new BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand(), model);
        BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand>): BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand {
        if (!model) return null;
        return BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand.newInstance(<BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand) {
        if (!obj) return;

        models.BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCloudHealthMonitoringParserOnDemand.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID that needs to processed
     */
    service_account_id: string;

    /**
     * Resource ID
     */
    resource_id: string;

    /**
     * Metric name
     */
    metric_name: string;

    /**
     * alert data in json encoded text
     */
    alert_data: string;

}
